import { connect } from "react-redux";
import InsuranceWrap from "../../../../itrust_common/components/authorised/patientFormPartial/InsuranceWrap";
import PersonalInformationTab from "../../../../itrust_common/components/authorised/patientFormPartial/PersonalInformationTab";
import { reduxForm } from "redux-form";
import ScrollToTarget from "../../../../itrust_common/components/others/ScrollToTarget";

function SecondaryPatientForm(props) {
  const { handleSubmit, template } = props

  return (
    <form onSubmit={handleSubmit}>
      <div id="patient-personal-tab">
        <PersonalInformationTab
          template={template}
          isTemplate={false}
          isLongForm={false}
        />
      </div>
      <InsuranceWrap
        template={template}
        isTemplate={false}
        isLongForm={false}
        formName="secondaryPatientForm"
      />
    </form>
  )
}

SecondaryPatientForm = reduxForm({
  form: 'secondaryPatientForm',
  enableReinitialize: true,
  shouldValidate: () => true,
  onSubmitFail: () => ScrollToTarget()
})(SecondaryPatientForm)

const mapStateToProps = (state) => {
  const { } = state
  const { patient_template } = state.setting.patientTemplate
  return {
    template: patient_template,
  }
}

export default connect(mapStateToProps)(SecondaryPatientForm);